import {
  alunoSelecionado,
  AlunosService,
} from '../../private/admin/pages/alunos/alunos.service';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '../button/button.component';
import { PerfilComponent } from '../perfil/perfil.component';
import { UserService } from '../services/user/user.service';
import { MenuService } from '../menu/menu.service';
import { NavbarService } from './navbar.service';
import { ModalService } from '../modal/modal.service';
import { AbrirModalChamadaComponent } from './components/abrir-modal-chamada/abrir-modal-chamada.component';
import { permissaoBehavior, PermissaoEnum } from '../../models/role.enum';
import { User } from '../../models/authentication.interface';

import { AlterarSenhaComponent } from '../../private/admin/pages/perfil/components/alterar-senha/alterar-senha.component';
import { RolesDirective } from '../directive/directive-roles.directive';
import { RoleNamePipe } from '../pipes/roleNames/role-name.pipe';
import { Tab } from '../tabs/tabs.component';
import { NotificationService } from '../services/notification/notification.service';
import { NotificationEntity } from '../services/notification/notification.model';
import { AbrirModalPerfilComponent } from './components/abrir-modal-perfil/abrir-modal-perfil.component';
import { StorageServiceService } from '../storage/storage-service.service';
import { Subscription } from 'rxjs';
import { SidebarService } from '../sidebar/sidebar.service';
import { SideNotification } from './components/side-notification/side-notification.component';

@Component({
  selector: 'navbar',
  standalone: true,
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  imports: [
    ButtonComponent,
    CommonModule,
    PerfilComponent,
    RolesDirective,
    RoleNamePipe,
  ],
})
export class NavbarComponent implements OnInit, OnDestroy {
  isOpen = true;
  // menu: Menu[] = [];
  isMenu = false;
  isDetail = false;
  newNotification = false;
  notifications: NotificationEntity[] = [];
  readCount: number = 0;
  unreadNotificationsCount: number = 0;
  title: any = '';
  user!: User;
  role: permissaoBehavior | undefined;
  counter = 0;
  tab: any;
  tabs: Tab[] = [
    {
      icon: '',
      label: 'Perfil',
      value: 'perfil',
      selected: false,
    },
    {
      icon: '',
      label: 'Configurações',
      value: 'configuracoes',
      selected: false,
    },
  ];
  alunoSelecionado: alunoSelecionado = {
    documentId: '',
    id: 0,
    nomeAluno: 'Aluno',
  };
  private boundHandler = this.handleRNMessage.bind(this);
  showNotificationDot = false;

  private readonly subscription: Subscription = new Subscription();

  constructor(
    private readonly service: NavbarService,
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly menuService: MenuService,
    private readonly modalService: ModalService,
    private readonly alunosService: AlunosService,
    private readonly notificationService: NotificationService,
    private readonly storageService: StorageServiceService,
    private cdr: ChangeDetectorRef,
    private readonly sidebarService: SidebarService,
  ) {
    this.title = service.title;
    this.userService.permissao.subscribe((value) => {
      if (value !== undefined) {
        this.role = value;
      }
    });

    this.alunosService.alunoSelecionado.subscribe((value) => {
      if (value !== null) {
        this.alunoSelecionado.nomeAluno = this.getFirstName(value.nomeAluno);
      } else {
        if (this.storageService.obterAluno() !== undefined) {
          this.alunoSelecionado =
            this.storageService.obterAluno() as alunoSelecionado;
        }
      }
    });
  }

  ngOnInit(): void {
    this.buscarUsuarioPorID();
    this.buscarNotificacoes();
    this.selecionarPerfil();
    if (window && (window as any).ReactNativeWebView) {
      window.addEventListener('message', this.boundHandler);
    }

    this.listenUnreadNotifications();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  selecionarPerfil() {
    const escola = this.storageService.obterEscola();
    const permissao = this.storageService.obterPermissao();

    const naoTemPerfilSelecionado =
      this.userService.escola.getValue() === undefined ||
      this.userService.permissao.getValue() === undefined;

    const temPerfilNoStorage = escola !== undefined && permissao !== undefined;

    if (naoTemPerfilSelecionado) {
      if (temPerfilNoStorage) {
        this.userService.escola.next(escola);
        this.userService.permissao.next(permissao);
        this.menuService.updateMenu();
      } else {
        this.modalService.open(AbrirModalPerfilComponent);
      }
    }
  }

  abrirModalPerfil() {
    this.modalService.open(AbrirModalPerfilComponent);
  }

  buscarNotificacoes() {
    this.notificationService.listNotificationsPaged(1, 5).subscribe((page) => {
      this.notifications = page.data;
      this.notificationService.updateUnreadCount(
        page.meta.pagination.total - this.readCount,
      );
    });
  }

  marcarTodasLidas() {
    this.notificationService.markAllAsRead().subscribe(() => {
      this.notifications.forEach((n) => (n.statuses = 'received'));
      this.notificationService.updateUnreadCount(0);
    });
  }

  getFirstName(fullName: string): string {
    if (!fullName) {
      return '';
    }
    const parts = fullName.trim().split(' ');
    return parts[0];
  }

  private handleRNMessage(event: MessageEvent) {
    try {
      const msg = JSON.parse(event.data);
      if (msg.type === 'NOTIFICATION' && msg.hasNew) {
        this.showNotificationDot = true;
        this.cdr.detectChanges();
      }
    } catch {}
  }

  buscarUsuarioPorID() {
    this.user = this.userService.user;
    this.user.name = this.getFirstName(this.userService.user.name);
  }

  changeTab(value: any) {
    this.tab = value;
  }

  irParaTermos() {
    this.router.navigate(['/admin/termos']);
    this.isMenu = false;
  }

  irParaPerfil() {
    this.router.navigate(['/admin/perfil']);
    this.isMenu = false;
    this.newNotification = false;
  }

  abrirModalEscolherAluno() {
    this.isMenu = false;
    // this.modalService.open(EscolherAlunoComponent);
  }

  abrirModalChamada() {
    this.modalService.open(AbrirModalChamadaComponent);
  }

  showHideDetail() {
    this.isDetail = !this.isDetail;
  }

  abrirNotificacoes() {
    this.sidebarService.openSide(SideNotification);
  }

  irFichaMedica() {
    this.router.navigate(['/admin/ficha-medica']);
    this.abrirMenu();
  }

  irHistorico() {
    this.router.navigate(['/admin/historico-aluno']);
    this.abrirMenu();
  }

  irDadosAluno() {
    this.router.navigate(['/admin/dados-aluno']);
    this.abrirMenu();
  }

  irDocumentos() {
    this.router.navigate(['/admin/documentos-aluno']);
    this.abrirMenu();
  }

  visualizarPerfil() {
    this.router.navigate(['/admin/perfil']);
    this.showHideDetail();
  }

  abrirModalAlterarSenha() {
    this.isMenu = false;
    this.modalService.open(AlterarSenhaComponent);
  }

  abrirMenu() {
    this.isMenu = !this.isMenu;
  }

  logout() {
    window.sessionStorage.removeItem('token');
    window.sessionStorage.removeItem('user');
    this.menuService._menu.next([]);
    this.isDetail = false;
    this.userService.usuario.next(undefined);
    this.storageService.limpar();
    this.userService.permissao.next(undefined);
    this.userService.escola.next(undefined);
    this.router.navigate(['/login']);
  }

  private listenUnreadNotifications(): void {
    this.subscription.add(
      this.notificationService.getUnreadCount().subscribe((unreadCounter) => {
        this.unreadNotificationsCount = unreadCounter;
      }),
    );
  }

  protected readonly PermissaoEnum = PermissaoEnum;
}
